import { Client } from '@/types';
import api from '@/api/API';
import eventBus from '@/messaging/event-bus';
import { ClientAdded } from '@/messaging/events';

// eslint-disable-next-line import/prefer-default-export
export function add(agencyId: string, externalId: string): Promise<Client> {
  return api
    .post(`agencies/${agencyId}/clients`, { externalId })
    .then((response) => {
      const result = (response as unknown as Client);
      eventBus.$emit(ClientAdded.eventName, result);
      return result;
    });
}
